import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
import { pagesList } from "Apis/pages";
import { eventList } from "Apis/event";

export const BannerContext = createContext();

export const BannerContextProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [formIsEdit, setFormIsEdit] = useState(false);
  const [editData, setEditData] = useState([]);
  const [pageList, setPageList] = useState([]);
  const [eventListData, setEventListData] = useState([]);

  const allPagesList = async () => {
    const response = await pagesList({
      filters: {
        slug: "home_page",
      },
    });
    const pages = response?.data?.data?.rows?.map((data) => ({
      label: data?.slug.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase()),
      value: data?.slug,
    }));
    setPageList(pages);
  };

  const getEventApi = async () => {
    let response = await eventList();
    if (response?.status === 200) {
      setEventListData(
        response.data.data.rows?.map((item) => ({
          id: parseInt(item?.id),
          label: item?.title,
        }))
      );
    }
  };

  const handleOpenModal = () => {
    setOpen(true);
    setFormIsEdit(false);
  };

  return (
    <BannerContext.Provider
      value={{
        open,
        setOpen,
        formIsEdit,
        setFormIsEdit,
        handleOpenModal,
        editData,
        setEditData,
        pageList,
        setPageList,
        allPagesList,
        eventListData,
        setEventListData,
        getEventApi,
      }}
    >
      {children}
    </BannerContext.Provider>
  );
};

export default BannerContextProvider;
BannerContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
